import { createSelector } from 'redux-orm';
import orm from '%paysera_seat_selection/js/seatSelection/redux/model';
import { resolveObjectsByRectangle } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/resolveObjectByCoordinates';
import { getSelectableObjects, getSelectableSeats } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/getSelectableObjects';
import { selectModifierKeys } from '%paysera_seat_selection/js/seatSelection/redux';
import { KEY_CODE_ALT } from '%paysera_seat_selection/js/seatSelection/config/constants';
import dbSelector from './dbSelector';

const selectObjectsByRectangle = createSelector(
    orm,
    dbSelector,
    (state, rectangle, selection) => ({ state, rectangle, selection }),
    (session, { state, rectangle, selection }) => {
        if (rectangle === null || selection === null) {
            return [];
        }

        const modifierKeys = selectModifierKeys(state);
        let objects = [];

        if (modifierKeys.includes(KEY_CODE_ALT)) {
            objects = getSelectableSeats(session, selection);
        } else {
            objects = getSelectableObjects(session, selection);
        }

        return resolveObjectsByRectangle(objects, rectangle);
    },
);

export default selectObjectsByRectangle;
